import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { connect as connectFormik } from 'formik'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import { adPriceTypes } from 'Core/constants'
import { Checkbox } from 'SRC/ui/FormElements'
import { Header } from 'SRC/modules/ads/shared/components/FormElements'
import { Price } from '../Price'
import { Description } from '../Description'
import { Swapps } from '../Swapps'

const Container = ({ category, hasPriceFromToAddon, hasPriceOnRequestAddon, hasDeliveryAddon, formType, formik }) => {
  const hasPriceSpecification = category && category.hasPriceSpecification

  const isBuyingAd = formik.values && formik.values.isBuying

  return (
    <React.Fragment>
      <Header title='Cijena, opis i zamjena' key='header' />

      <div className='ads-add__price-description'>
        <div className='left-inputs' key='left-fields'>
          {/* Price */}
            {!hasPriceSpecification ? (
              <Price
                hasPriceFromToAddon={hasPriceFromToAddon}
                hasPriceOnRequestAddon={hasPriceOnRequestAddon}
                hasDeliveryAddon={hasDeliveryAddon}
                formType={formType}
              />
            ) : null}
        </div>

        {/* Description */}
        <Description key='description-field' />
      </div>
      
      {/* Swapps */}
      {!isBuyingAd ? <Swapps key='swap-field' /> : null}
    </React.Fragment>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    category: getCurrentSubCategory(state)
  }
}

Container.displayName = 'PriceSwappDescription'

const enhance = compose(
  connect(mapStateToProps),
  connectFormik
)

export default enhance(Container)
